module.exports = __webpack_public_path__ + "img/rain_orange.bc69c7dc.gif";